import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import Loading from '../Common/Loading';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  
  useEffect(() => {
    // Only show login prompt after a short delay
    // This prevents immediate redirect and gives user a chance to see where they are
    let timer;
    
    if (!isLoading && !isAuthenticated) {
      timer = setTimeout(() => {
        setShowLoginPrompt(true);
      }, 1500); // 1.5 second delay
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isAuthenticated, isLoading]);
  
  // Handle the login redirect
  const handleLogin = () => {
    loginWithRedirect({
      appState: { returnTo: window.location.pathname },
      prompt: 'login', // Always show login screen to prevent auto sign-in issues
    });
  };
  
  if (isLoading) {
    return <Loading />;
  }
  
  if (!isAuthenticated) {
    if (showLoginPrompt) {
      // Show a login prompt instead of automatically redirecting
      return (
        <div style={{ 
          maxWidth: '500px', 
          margin: '100px auto', 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#1d1d1d',
          color: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }}>
          <h2>Authentication Required</h2>
          <p>You need to be logged in to access this page.</p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
            <button 
              onClick={handleLogin}
              style={{
                backgroundColor: '#ff1744',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '10px 20px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Log In
            </button>
            <button 
              onClick={() => navigate('/')}
              style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: '1px solid white',
                borderRadius: '4px',
                padding: '10px 20px',
                cursor: 'pointer'
              }}
            >
              Return to Home
            </button>
          </div>
        </div>
      );
    }
    
    // Show loading while waiting to display the login prompt
    return <Loading />;
  }
  
  return children;
};

export default AuthGuard;